import React from 'react';
import SvgIcon from './SvgIcon';

const Like = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M20.25 13.125H21a1.5 1.5 0 100-3h-8.25c.502-2.215.753-4.479.75-6.75a1.5 1.5 0 10-3 0s-1.5 8.25-6.75 8.25H1.5v9h3.75c1.5 0 4.5 1.5 6 1.5h7.5a1.5 1.5 0 100-3h.75a1.5 1.5 0 100-3h.75a1.5 1.5 0 100-3z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Like.displayName = 'LikeIcon';

export default Like;
